import { getApiUrl } from '../config/api';

/**
 * Envía el token FCM al backend (usuario + appid del login; el token es de Firebase, no el appid).
 */
async function registrarEnBackend(user, token) {
  const tokenStr = token != null ? String(token).trim() : '';
  if (!user?.username || !tokenStr) {
    return { ok: false, error: 'usuario o token vacío' };
  }

  try {
    const res = await fetch(getApiUrl('ALERTA_VIGILANCIA', 'FCM_TOKEN'), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        usuario: user.username,
        appid: user.appid || null,
        token: tokenStr
      })
    });
    const data = await res.json().catch(() => ({}));
    if (!res.ok || data.success === false) {
      console.warn('[FCM] No se pudo registrar token:', data.error || res.status);
      return { ok: false, error: data.error || `HTTP ${res.status}` };
    }
    console.info('[FCM] Token registrado en backend');
    return { ok: true };
  } catch (err) {
    console.warn('[FCM] Error de red registrando token:', err);
    return { ok: false, error: err?.message || 'network' };
  }
}

/**
 * Obtiene el FCM token vía bridge nativo de la APK (callback) y lo registra.
 *
 * Flujo Suri / Android:
 * 1. JS define window.onAndroidToken(token)
 * 2. JS llama AndroidInterface.getFirebaseToken() (void; no retorna el token)
 * 3. La APK, cuando tiene el token, ejecuta window.onAndroidToken('...')
 *
 * En navegador normal (sin AndroidInterface) no hace nada.
 * El appid del login no se toca: solo se reenvía junto al token FCM.
 */
export async function registrarTokenFcmDesdeAndroid(user) {
  if (typeof window === 'undefined' || !user?.username) {
    return { skipped: true };
  }

  const bridge = window.AndroidInterface;
  if (!bridge || typeof bridge.getFirebaseToken !== 'function') {
    return { skipped: true, reason: 'no_android_interface' };
  }

  // Callback que la APK invocará con el token FCM
  window.onAndroidToken = (token) => {
    console.info('[FCM] Token recibido de la APK (onAndroidToken)');
    registrarEnBackend(user, token).catch(() => {});
  };

  try {
    // void en Android (@JavascriptInterface); el resultado llega por onAndroidToken
    bridge.getFirebaseToken();
    return { ok: true, pending: true };
  } catch (err) {
    console.warn('[FCM] AndroidInterface.getFirebaseToken falló:', err);
    return { ok: false, error: err?.message || 'getFirebaseToken error' };
  }
}
